"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classNames = require("classnames");
exports.default = (function (props) { return (React.createElement("svg", __assign({}, props, { "data-name": "Layer_2", viewBox: "0 0 26 26", xmlns: "http://www.w3.org/2000/svg", className: classNames('sok-svg-icon', props.className) }),
    React.createElement("path", { fill: "#FF7D01", d: "M26,23c0,1.6-1.4,3-3,3H3c-1.6,0-3-1.4-3-3V3c0-1.6,1.4-3,3-3h20c1.6,0,3,1.4,3,3V23z" }),
    React.createElement("path", { fill: "#FFFFFF", d: "M13,20.7c-4.3,0-7.7-3.5-7.7-7.7S8.8,5.3,13,5.3s7.7,3.5,7.7,7.7S17.3,20.7,13,20.7z M13,7.5\n\t\tc-3,0-5.5,2.5-5.5,5.5s2.5,5.5,5.5,5.5s5.5-2.5,5.5-5.5S16,7.5,13,7.5z M14.3,14c0,0.2-0.1,0.3-0.3,0.3h-3.2\n\t\tc-0.2,0-0.3-0.1-0.3-0.3v-0.6c0-0.2,0.1-0.3,0.3-0.3H13V9.5c0-0.2,0.1-0.3,0.3-0.3H14c0.2,0,0.3,0.1,0.3,0.3V14z" }))); });
//# sourceMappingURL=UploadIFCOrange.js.map